(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dio-dealer-directory"] && !Shopify.designMode) return;
  try {
    
(() => {
  const normalize = value => String(value ?? '').normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/&/g, ' and ').replace(/[^a-z0-9]+/g, ' ').trim();
  const compact = value => normalize(value).replace(/ /g, '');
  const distance = (a, b, c, d) => {
    const rad = Math.PI / 180;
    const h = Math.sin((c - a) * rad / 2) ** 2 + Math.cos(a * rad) * Math.cos(c * rad) * Math.sin((d - b) * rad / 2) ** 2;
    return 3958.7613 * 2 * Math.asin(Math.sqrt(Math.min(1, Math.max(0, h))));
  };
  const locationKey = row => [normalize(row.aliases).includes('tractor supply') || /^(tsc|tractor supply)\b/i.test(row.name) ? 'tractorsupply' : compact(row.name), compact(row.address), compact(row.address2), row.country, compact(row.postal)].join('|');
  const coordinate = (value, limit) => {
    if (typeof value === 'string') value = value.trim() === '' ? null : Number(value);
    return typeof value === 'number' && Number.isFinite(value) && Math.abs(value) <= limit ? value : null;
  };
  const mergeRows = (base, updates, regions) => {
    const result = new Map(base.map(row => [locationKey(row), { ...row }]));
    for (const update of updates) {
      if (!update.data?.name || !update.data?.id) continue;
      const row = { ...update.data };
      // Flow can serialize missing coordinates as "null". Preserve any known pair.
      const lat = coordinate(row.lat, 90), lng = coordinate(row.lng, 180);
      const hasCoords = lat !== null && lng !== null && !(lat === 0 && lng === 0);
      row.lat = hasCoords ? lat : null;
      row.lng = hasCoords ? lng : null;
      if (row.online === 'true' || row.online === 'false') row.online = row.online === 'true';
      const key = locationKey(row);
      if (update.visible === false) { result.delete(key); continue; }
      const old = result.get(key) || {};
      const merged = { ...old };
      for (const [field, value] of Object.entries(row)) if (value !== '' && value !== null && value !== undefined) merged[field] = value;
      result.set(key, merged);
    }
    return [...result.values()].map(row => {
      row.region = Object.keys(regions).find(code => code === row.region || normalize(regions[code]) === normalize(row.region)) || row.region || '';
      row.regionName = regions[row.region] || row.region;
      row._index = normalize([row.name, row.aliases, row.address, row.address2, row.city, row.region, row.regionName, row.postal, row.storeNumber].join(' '));
      row._postal = compact(row.postal);
      row._hasCoords = typeof row.lat === 'number' && typeof row.lng === 'number' && Number.isFinite(row.lat) && Number.isFinite(row.lng) && Math.abs(row.lat) <= 90 && Math.abs(row.lng) <= 180 && !(row.lat === 0 && row.lng === 0);
      return row;
    });
  };
  const findRows = (rows, filters) => {
    const query = normalize(filters.query);
    const tokens = query.split(' ').filter(Boolean);
    const postal = compact(filters.query);
    const regionOnly = /^[A-Z]{2}$/.test(filters.query.trim()) && rows.some(r => r.region === filters.query.trim());
    return rows.filter(row => (!filters.country || row.country === filters.country) && (!filters.region || row.region === filters.region) && (!tokens.length || (regionOnly ? row.region === filters.query.trim() : tokens.every(token => row._index.includes(token)) || row._postal.includes(postal))) && (!filters.origin || filters.radius === Infinity || (row._hasCoords && row._distance <= filters.radius))).sort((a, b) => {
      if (filters.origin) { const diff = (a._distance ?? Infinity) - (b._distance ?? Infinity); if (diff) return diff; }
      if (query) { const exact = Number(normalize(b.name).includes(query)) - Number(normalize(a.name).includes(query)); if (exact) return exact; }
      return (Number(b.priority) || 0) - (Number(a.priority) || 0) || a.name.localeCompare(b.name) || (a.city || '').localeCompare(b.city || '') || a.id.localeCompare(b.id);
    });
  };
  class DealerDirectory extends HTMLElement {
    connectedCallback() { if (!this.ready) { this.ready = true; requestAnimationFrame(() => this.init()); } }
    init() {
      try {
        this.copy = JSON.parse(this.querySelector('[data-copy]').textContent);
        this.regions = JSON.parse(this.querySelector('[data-regions]').textContent);
        this.base = [...this.querySelectorAll('[data-dealers]')].flatMap(el => JSON.parse(el.textContent));
        this.liveEl = this.querySelector('[data-live-dealers]');
        this.updates = JSON.parse(this.liveEl.textContent);
        this.rows = mergeRows(this.base, this.updates, this.regions);
        this.queryInput = this.querySelector('[data-query]');
        this.countryInput = this.querySelector('[data-country]');
        this.regionInput = this.querySelector('[data-region]');
        this.radiusInput = this.querySelector('[data-radius]');
        this.list = this.querySelector('[data-results]');
        this.status = this.querySelector('[data-status]');
        this.message = this.querySelector('[data-message]');
        this.page = 1;
        this.origin = null;
        this.populateCountries();
        this.populateRegions();
        this.queryInput.addEventListener('input', () => { clearTimeout(this.timer); this.timer = setTimeout(() => { this.page = 1; this.render(); }, 100); });
        this.querySelector('form').addEventListener('submit', e => { e.preventDefault(); clearTimeout(this.timer); this.page = 1; this.render(); this.status.focus({ preventScroll: true }); });
        this.countryInput.addEventListener('change', () => { this.populateRegions(); this.page = 1; this.render(); });
        this.regionInput.addEventListener('change', () => { this.page = 1; this.render(); });
        this.radiusInput.addEventListener('change', () => { this.page = 1; this.render(); });
        this.querySelector('[data-locate]').addEventListener('click', () => this.locate());
        this.querySelector('[data-clear]').addEventListener('click', () => this.clear());
        this.querySelector('[data-prev]').addEventListener('click', () => { this.page--; this.render(true); });
        this.querySelector('[data-next]').addEventListener('click', () => { this.page++; this.render(true); });
        this.querySelector('[data-retry]').addEventListener('click', () => this.loadMoreRecords());
        this.querySelector('[data-controls]').disabled = false;
        this.render();
        this.loadMoreRecords();
      } catch (error) {
        this.querySelector('[data-status]').textContent = this.copy?.load_error || 'The directory could not load. Please contact us for help finding a retailer.';
      }
    }
    text(key, values = {}) { let text = this.copy[key] || key; for (const [k,v] of Object.entries(values)) text = text.replaceAll('['+k+']', String(v)); return text; }
    countryName(code) { return ({US:this.copy.us, CA:this.copy.ca, GB:this.copy.gb})[code] || code || this.copy.other; }
    populateCountries() {
      const current = this.countryInput.value;
      this.countryInput.replaceChildren(new Option(this.copy.all_countries, ''));
      const countries = [...new Set(this.rows.map(r => r.country).filter(Boolean))].sort((a,b) => this.countryName(a).localeCompare(this.countryName(b)));
      for (const country of countries) this.countryInput.add(new Option(this.countryName(country),country));
      if (countries.includes(current)) this.countryInput.value = current;
    }
    populateRegions() {
      const old = this.regionInput.value;
      this.regionInput.replaceChildren(new Option(this.copy.all_regions,''));
      const regions = [...new Set(this.rows.filter(r => !this.countryInput.value || r.country === this.countryInput.value).map(r => r.region).filter(Boolean))].sort((a,b) => (this.regions[a] || a).localeCompare(this.regions[b] || b));
      for (const region of regions) this.regionInput.add(new Option(this.regions[region] || region,region));
      if (regions.includes(old)) this.regionInput.value = old;
    }
    render(scroll = false) {
      const radius = this.radiusInput.value === 'any' ? Infinity : Number(this.radiusInput.value);
      const matched = findRows(this.rows,{query:this.queryInput.value,country:this.countryInput.value,region:this.regionInput.value,origin:this.origin,radius});
      const pages = Math.max(1,Math.ceil(matched.length/24));
      this.page = Math.min(pages,Math.max(1,this.page));
      const start = (this.page-1)*24;
      const slice = matched.slice(start,start+24);
      this.list.replaceChildren(...slice.map(row => this.card(row)));
      this.status.textContent = matched.length ? this.text('result_count',{start:start+1,end:start+slice.length,total:matched.length.toLocaleString()}) : this.copy.no_results;
      this.querySelector('[data-empty]').hidden = matched.length > 0;
      this.querySelector('[data-pagination]').hidden = pages <= 1;
      this.querySelector('[data-page]').textContent = this.text('page_count',{page:this.page,pages});
      this.querySelector('[data-prev]').disabled = this.page === 1;
      this.querySelector('[data-next]').disabled = this.page === pages;
      this.querySelector('[data-nearby-note]').hidden = !this.origin;
      this.querySelector('[data-range]').hidden = !this.origin;
      if (scroll) { this.status.scrollIntoView({block:'start',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'}); this.status.focus({preventScroll:true}); }
    }
    card(row) {
      const card = document.createElement('article'); card.className = 'dio-locator-card';
      const place = document.createElement('p'); place.className = 'dio-locator-place'; place.textContent = [row.city,row.region].filter(Boolean).join(', ') || this.countryName(row.country); card.append(place);
      const heading = document.createElement('h3'); heading.textContent = row.name; card.append(heading);
      if (row.storeNumber || row.online) { const badge = document.createElement('p'); badge.className = 'dio-locator-detail'; badge.textContent = row.online ? this.copy.online_store : this.text('store_number',{number:row.storeNumber}); card.append(badge); }
      const address = document.createElement('address');
      for (const line of [row.address,row.address2,[row.city,row.region,row.postal].filter(Boolean).join(' '),this.countryName(row.country)].filter(Boolean)) { const span = document.createElement('span'); span.textContent = line; address.append(span); }
      card.append(address);
      if (this.origin) { const miles = document.createElement('p'); miles.className = 'dio-locator-distance'; miles.textContent = row._hasCoords ? this.text('miles_away',{miles:row._distance<1?'<1':Math.round(row._distance).toLocaleString()}) : this.copy.distance_unavailable; card.append(miles); }
      const links = document.createElement('div'); links.className = 'dio-locator-card-links';
      const addLink = (label,href,external) => { const a = document.createElement('a'); a.textContent = label; a.href = href; if(external) {a.target='_blank';a.rel='noopener noreferrer';a.setAttribute('aria-label',this.text('new_window',{label}));} links.append(a); };
      if (row.address && !row.online && !/^p\.?\s*o\.?\s*box|^box\s/i.test(row.address)) { const url = new URL('https://www.google.com/maps/dir/'); url.searchParams.set('api','1'); url.searchParams.set('destination',[row.address,row.address2,row.city,row.region,row.postal,this.countryName(row.country)].filter(Boolean).join(', ')); addLink(this.copy.directions,url.href,true); }
      const phone = String(row.phone || '').replace(/[^+\d]/g,''); if(phone.replace(/\D/g,'').length>=7) addLink(this.copy.call,'tel:'+phone,false);
      if(row.website) { try { const url = new URL(row.website); if(['http:','https:'].includes(url.protocol)) addLink(this.copy.website,url.href,true); } catch {} }
      card.append(links); return card;
    }
    clear() {
      this.geoRequest = (this.geoRequest || 0)+1;
      this.queryInput.value = ''; this.countryInput.value = ''; this.regionInput.value = ''; this.radiusInput.value = '50'; this.origin = null; this.page = 1;
      this.querySelector('[data-locate]').disabled = false;
      this.querySelector('[data-locate]').textContent = this.copy.locate;
      this.message.textContent = ''; this.populateRegions(); this.render(); this.queryInput.focus();
    }
    locate() {
      if(!navigator.geolocation) { this.message.textContent=this.copy.geo_unavailable; return; }
      const request = this.geoRequest = (this.geoRequest || 0)+1;
      const button=this.querySelector('[data-locate]'); button.disabled=true; button.textContent=this.copy.locating;
      this.message.textContent=this.copy.geo_permission;
      navigator.geolocation.getCurrentPosition(position => {
        if(request!==this.geoRequest || !this.isConnected) return;
        this.origin = {lat:position.coords.latitude,lng:position.coords.longitude};
        for (const row of this.rows) row._distance = row._hasCoords ? distance(this.origin.lat,this.origin.lng,row.lat,row.lng) : null;
        this.queryInput.value=''; this.countryInput.value=''; this.regionInput.value=''; this.populateRegions(); this.page=1;
        button.disabled=false;button.textContent=this.copy.locate;this.message.textContent=this.copy.geo_ready;this.render();
      }, error => { if(request!==this.geoRequest || !this.isConnected) return; button.disabled=false;button.textContent=this.copy.locate;this.message.textContent=error.code===1?this.copy.geo_denied:this.copy.geo_unavailable; }, {enableHighAccuracy:false,timeout:10000,maximumAge:300000});
    }
    async loadMoreRecords() {
      if(this.loading || Number(this.liveEl.dataset.pages)<=1) return;
      this.loading=true; const retry=this.querySelector('[data-retry]');retry.hidden=true;
      const seen = new Set(this.updates.map(r=>r.handle));
      try {
        for(let page=2;page<=Number(this.liveEl.dataset.pages);page++) {
          const url=new URL(location.href);url.searchParams.set('section_id','dio-dealer-feed');url.searchParams.set(this.liveEl.dataset.param || 'page',String(page));
          const response=await fetch(url.href,{credentials:'same-origin',signal:AbortSignal.timeout(12000)});if(!response.ok)throw new Error('data');
          const doc=new DOMParser().parseFromString(await response.text(),'text/html');
          const source=doc.querySelector('[data-live-dealers]');if(!source)throw new Error('data');
          for(const row of JSON.parse(source.textContent))if(!seen.has(row.handle)){seen.add(row.handle);this.updates.push(row);}
        }
        this.rows=mergeRows(this.base,this.updates,this.regions);
        if(this.origin)for(const row of this.rows)row._distance=row._hasCoords?distance(this.origin.lat,this.origin.lng,row.lat,row.lng):null;
        this.populateCountries();this.populateRegions();this.render();
      } catch { this.message.textContent=this.copy.partial_error;retry.hidden=false; }
      finally {this.loading=false;}
    }
  }
  if(!customElements.get('dio-dealer-directory'))customElements.define('dio-dealer-directory',DealerDirectory);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["g_password-footer"]) return;
  try {
    
    const pwdFooter = document.querySelector('[data-password-footer]');
    document.documentElement.style.setProperty('--password-footer-height', `${pwdFooter.offsetHeight}px`);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["g_password-header"]) return;
  try {
    
    const pwdHeader = document.querySelector('[data-password-header]');
    document.documentElement.style.setProperty('--password-header-height', `${pwdHeader.offsetHeight}px`);

  } catch(e) { console.error(e); }
})();
})();
